<template>
  <div class="preloader">
    <img :src="publicPath+'assets/images/logo.png'" alt="Logo png" loading="eager" />
  </div>
</template>

<script>
export default {
  name: "PreLoader",
  components: {},

  data() {
    return {
      publicPath:process.env.VUE_APP_PUBLIC_PATH ?? "/",
    };
  },
  mounted() {},
  created() {},
};
</script>

<style>
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #20314d;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: hidden;
  min-height: 100vh;
}

.preloader img {
  max-width: 200px;
  max-height: 200px;
}
</style>
